import { Dialog, DialogActions, DialogContent, DialogTitle, Paper, Button, List, TextField, Checkbox, ListItem, ListItemText, Divider, CircularProgress, Chip, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useState } from 'react';
import { globalGetService } from '../../globalServices';
import { checkApiStatus } from '../utils_v2';
import { trackActivity } from '../../utils/mixpanel';
import { numberWithCommas } from '../../utils';

const LinkingPopup = ({ placeholder, url, toggleModalFn, title, linkUnlink, circularloader, description, isSvEvents, isEngine, isApu, tableView }) => {

  const [search, setSearch] = useState('');
  const [checked, setChecked] = useState([]);
  const [listing , SetListing] = useState({});
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    getPopupList();
  },[])

   const getPopupList = () => {
          setIsLoading(true)
          globalGetService(url)
              .then(response => {
                  if (checkApiStatus(response)) {
                      SetListing(response?.data)
                  }
                  setIsLoading(false)
              })
      }

  const handleToggle = (value) => {
  const currentIndex = checked.indexOf(value.id);
  const newChecked = [...checked];

  if (currentIndex === -1) {
    newChecked.push(value.id);
  } else {
    newChecked.splice(currentIndex, 1);
  }

  setChecked(newChecked);
};

  return (
    <Dialog className='console-management-modal' maxWidth="md" style={{ maxHeight: "600px" }} open={true}>
      <DialogTitle>Link {title}</DialogTitle>
      <DialogContent dividers style={tableView ? { width: "750px", padding: "0", display: "flex", flexDirection: "column", maxHeight: "480px", overflow: "hidden" } : { width: "500px", paddingTop: "0px" }}>
        <div style={{position: tableView ? "static" : "sticky", top:"0", zIndex:"1", flexShrink: 0, background: '#fff', padding: '12px'}}>
          <Paper>
            <TextField
              fullWidth
              placeholder={placeholder || "Search..."}
              variant='outlined'
              size='small'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Paper>
        </div>
        {isLoading ? (
          <div style={{ textAlign: 'center', padding: '24px' }}><CircularProgress size={28} /></div>
        ) : tableView ? (
          <div style={{ flexShrink: 1, minHeight: 0, maxHeight: '400px', overflow: 'auto', padding: '0 12px 12px' }}>
            <Table size="small" className="mui-table-format" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Event</TableCell>
                  <TableCell>Hours</TableCell>
                  <TableCell>Cycles</TableCell>
                  <TableCell>Months</TableCell>
                  <TableCell>Days</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(listing?.data || []).filter(entry => entry?.name?.toLowerCase().includes(search.toLowerCase())).length === 0 ? (
                  <TableRow><TableCell colSpan={6} style={{ textAlign: 'center' }}>No Shop Visit Events is available to link</TableCell></TableRow>
                ) : (
                  (listing?.data || []).filter(entry => entry?.name?.toLowerCase().includes(search.toLowerCase())).map((entry, index) => (
                    <TableRow key={index} hover onClick={() => handleToggle(entry)} style={{ cursor: 'pointer' }}>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={checked.includes(entry.id)}
                          tabIndex={-1}
                          disableRipple
                          color="primary"
                        />
                      </TableCell>
                      <TableCell>{entry?.name || '--'}</TableCell>
                      <TableCell>{numberWithCommas(entry?.hours)}</TableCell>
                      <TableCell>{numberWithCommas(entry?.cycles)}</TableCell>
                      <TableCell>{numberWithCommas(entry?.months)}</TableCell>
                      <TableCell>{numberWithCommas(entry?.days)}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </div>
        ) : (
          <List>
          {listing?.data?.length && (listing?.data || []).filter(entry => entry?.name?.toLowerCase().includes(search.toLowerCase())).length === 0 ? (
              <p style={{textAlign:"center"}}>No results found</p>
            )
            :
            ((listing?.data || []).filter(entry => entry?.name?.toLowerCase().includes(search.toLowerCase())).map((entry, index) => (
              <React.Fragment key={index}>
                <ListItem button onClick={() => handleToggle(entry)} dense>
                  <Checkbox
                    edge="start"
                    checked={checked.includes(entry.id)}
                    tabIndex={-1}
                    disableRipple
                    color="primary"
                  />
                  <ListItemText primary={`${entry?.name}${entry?.remarks ? ` (${entry.remarks})` : ''}`} />
                   {isSvEvents || isEngine || isApu ? <Chip variant="outlined" size="small" label={entry?.asset_type?.label} style={{fontSize:"12px", maxWidth:"150px" }} /> : null}
                </ListItem>
                <Divider />
              </React.Fragment>
            ))
            )}
        </List>
        )}
          {!tableView&&<p style={tableView ? { flexShrink: 0, margin: '8px 12px' } : undefined}>{!listing?.data?.length ? <div style={{textAlign:"center"}}>{description}</div> : null}</p>}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Types View Page', item_type: 'Cancel Button', event_type: 'Item Clicked', event_desc: `Clicked on Cancel Button from ${title} Linking Modal` }) }} color='primary' size='small' variant='outlined'>Cancel</Button>
        <Button variant="contained" size='small'
          onClick={() => {
            linkUnlink('link', checked);
            trackActivity('Console Management', {
              page_title: 'Config Data : Aircraft Types View Page',
              item_type: 'Linked Button',
              event_type: 'Item Clicked',
              event_desc: `Clicked on link Button from ${title} Linking Modal`
            });
          }}
          disabled={isLoading || !checked.length} color="primary" >
           {circularloader ? <CircularProgress size={20} /> : 'Link'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default LinkingPopup